export default __webpack_public_path__ + "static/media/voucher-campaign.333d799f.png";